module.exports = __webpack_public_path__ + "static/media/card_icon_12.30a5a394.png";